import type { CsnSearchVenue } from '@/models/CsnSearchVenue';

// limit 4d ads on top of the list - default is 2
export function filterOut4DiamondAdsMax(venues: CsnSearchVenue[], max = 2): CsnSearchVenue[] {
  let totalFourDiamondAds = 0;
  return venues.filter(venue => venue.featuredLevel !== 'FOUR_DIAMOND' || totalFourDiamondAds++ < max);
}

// merge competitive and video ads to show on UI
export function mergeCompAndVideoAds(compMarketAds: CsnSearchVenue[], videoAds: CsnSearchVenue[]): CsnSearchVenue[] {
  const adVenues: CsnSearchVenue[] = [];
  if (compMarketAds.length > 0 && videoAds.length > 0) {
    adVenues.push(compMarketAds[0]);
    adVenues.push(videoAds[0]);
    if (compMarketAds.length > 1) {
      adVenues.push(compMarketAds[1]);
    } else if (videoAds.length > 1) {
      adVenues.push(videoAds[1]);
    }
  } else {
    if (compMarketAds.length > 0) {
      adVenues.push(...compMarketAds.slice(0, 3));
    }
    if (videoAds.length > 0) {
      adVenues.push(...videoAds.slice(0, 3));
    }
  }
  return adVenues;
}
